import React, { memo, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import ArmsIcon from 'assets/machines/arms.svg'
import ArmsWorkingIcon from 'assets/machines/arms-working.svg'
import { MACHINE_TYPES } from 'constants/machines'
import Product from 'components/Product'

function MachineQuarter({ empty, machineType, quarter, product, isProducing }) {
  const { t } = useTranslation()
  const text = useMemo(() => `${t('machine.quarter')}${quarter}`, [quarter])
  const producingClass = isProducing ? 'producing' : ''

  if (machineType === MACHINE_TYPES.full_automatic_machine) {
    return (
      <div className={`machine-quarter machine-quarter--${MACHINE_TYPES.full_automatic_machine}`}>
        <div
          className={`machine-quarter__${MACHINE_TYPES.full_automatic_machine} ${producingClass}`}
        >
          <img
            src={empty ? ArmsIcon : ArmsWorkingIcon}
            alt="machine arms"
            className={`machine-quarter__arms ${producingClass}`}
          />
          {!empty && (
            <>
              <div
                className={`machine-quarter__text ${
                  product ? 'machine-quarter__text--active' : ''
                }`}
              >
                {text}
              </div>
              {product && (
                <div className="machine-quarter__product">
                  <Product product={product} withMU />
                </div>
              )}
            </>
          )}
        </div>
      </div>
    )
  }

  if (empty) return null

  return (
    <div className="machine-quarter">
      <div className={`machine-quarter__text ${product ? 'machine-quarter__text--active' : ''}`}>
        {text}
      </div>
      {product && <Product product={product} withMU />}
    </div>
  )
}

MachineQuarter.propTypes = {
  empty: PropTypes.bool,
  machineType: PropTypes.string.isRequired,
  quarter: PropTypes.number.isRequired,
  product: PropTypes.shape({
    cost: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  }),
  isProducing: PropTypes.bool
}

MachineQuarter.defaultProps = {
  empty: false,
  product: null,
  isProducing: false
}

export default memo(MachineQuarter)
